import { create } from 'zustand';

interface State {
  showHelpToast: boolean;
  showDirectionsToast: boolean;
  showStartTransactionToast: boolean;
  showNoCreditToast: boolean;
  showChargerUnavailableToast: boolean;
  showConnectingToast: boolean;
  setShowHelpToast: (value: boolean) => void;
  setShowDirectionsToast: (value: boolean) => void;
  setShowStartTransactionToast: (value: boolean) => void;
  setShowNoCreditToast: (value: boolean) => void;
  setShowChargerUnavailableToast: (value: boolean) => void;
  setShowConnectingToast: (value: boolean) => void;
}

export const useToastStore = create<State>((set) => ({
  showHelpToast: false,
  showDirectionsToast: false,
  showStartTransactionToast: false,
  showNoCreditToast: false,
  showChargerUnavailableToast: false,
  showConnectingToast: false,
  setShowHelpToast: (value) => set(() => ({ showHelpToast: value })),
  setShowDirectionsToast: (value) =>
    set(() => ({ showDirectionsToast: value })),
  setShowStartTransactionToast: (value) =>
    set(() => ({ showStartTransactionToast: value })),
  setShowNoCreditToast: (value) => set(() => ({ showNoCreditToast: value })),
  setShowChargerUnavailableToast: (value) =>
    set(() => ({ showChargerUnavailableToast: value })),
  setShowConnectingToast: (value) =>
    set(() => ({ showConnectingToast: value })),
}));
